import { NumberRange } from 'util/number/number-in-range'
import { getProcedimentosConsideradosTooltipText } from 'view/acompanhamento/acompanhamento-condicao-saude/utils-acompanhamentoCondicaoSaude'

const title = {
  plural: 'Exames considerados',
  singular: 'Exame considerado',
}

export const EXAMES_CANCER_MAMA_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  ['Mamografia bilateral para rastreamento (0204030188)'],
  title
)

export const EXAMES_CANCER_COLO_UTERO_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  [
    'Exame citopatológico cérvico vaginal/microflora-rastreamento (0203010086)',
    'Exame citopatológico cérvico-vaginal/microflora (0203010019)',
    'Coleta de material do colo do útero para exame molecular de detecção de HPV (0201020076)',
    'Entrega de material obtido por auto coleta para exame molecular para detecção de HPV, no colo do útero (0201020084)',
    'Coleta de material do colo de útero para exame citopatológico (0201020033)',
  ],
  title
)

export const ULTIMA_CONSULTA_SAUDE_SEXUAL_REPRODUTIVA_TOOLTIP_TEXT = `CID-10 e CIAP-2 considerados:
Z70, Z700, Z701,Z702,Z703,Z708,Z709, P07, P08, P09,W10, W11, W12, W13, W14, W15, X01, X02, X03, X04, X05, X06, X07, X08, X09, X10, X11, X12, X13, X18, X20, X21, X22, X24, Y01, Y02, Y04, Y05, Y06, Y07, Y08, Y10, Y13, Y14, Y16, Y24`

export const RANGE_IDADE_RASTREIO_CANCER_COLO_UTERO: NumberRange = {
  min: 25,
  max: 64,
}

export const RANGE_IDADE_RASTREIO_CANCER_MAMA: NumberRange = {
  min: 50,
  max: 69,
}

export const RANGE_IDADE_RASTREIO_SAUDE_SEXUAL_REPRODUTIVA: NumberRange = {
  min: 14,
  max: 69,
}
